/**************
 Mobile Nav
 ***************/

const announcement = document.querySelector('#shopify-section-theme-announcement-static');
const header = document.querySelector('#header');
const slider = document.querySelector('#slider');

function updateMobileSliderPosition() {
    // calculate current scroll position
    const scrollPosition = window.scrollY;

    // calculate height of the announcement bar
    const announcementHeight = announcement.offsetHeight;

    // calculate height of the header
    const headerHeight = header.offsetHeight;

    // calculate total offset top
    // we need to subtract the lesser of the announcement height or the scroll position since the announcement bar is static and the header is sticky
    const totalOffsetTop = announcementHeight + headerHeight - Math.min(announcementHeight, scrollPosition);

    // set the slider top position
    slider.style.top = `${totalOffsetTop}px`;

    // set the slider height
    slider.style.height = `${document.documentElement.clientHeight - totalOffsetTop}px`;
}

// initial position
updateMobileSliderPosition();

// change as sticky header activates
window.addEventListener('scroll', updateMobileSliderPosition);
window.addEventListener('resize', updateMobileSliderPosition);

// open nav
function openNav() {
    slider.showModal();
    document.querySelector("body").classList.add("noScroll");
    header.querySelector('#headerExit').classList.add("active");
}

// close nav
function closeNav() {
    slider.close();
    document.querySelector("body").classList.remove("noScroll");
    header.querySelector('#headerExit').classList.remove("active");
}

//open menu event
document.querySelector("#headerMenu")?.addEventListener("click", function () {
    openNav();
})

// toggle menu open/close
header.querySelector('#headerExit')?.addEventListener('click', function () {
    closeNav();
})

// close nav when clicking backdrop event listener
document.querySelector("#slider").addEventListener("click", function (event) {
    if (event.target === this) {
        closeNav();
    }
});

// register dialog
dialogPolyfill.registerDialog(slider);